import { OrganizationSwitcher } from "./OrganizationSwitcher";
import { AppSwitcher } from "./AppSwitcher";
import { UserPreferenceManager } from "./UserPreferenceManager";
import { ApprovalNotification } from "./ApprovalNotification";
import { ActivityNotification } from "./ActivityNotification";
import { UserNotification } from "./UserNotification";
import { AssistantTrigger } from "./assistant/AssistantTrigger";

// The global top bar — persists across every action. Approval bell is always
// visible (even at zero pending) so the user always knows where the inbox lives.
export function MainMenuManager() {
    return (
        <header className="app-header">
            <OrganizationSwitcher />
            <div className="app-header__sep" />
            <AppSwitcher />

            <div className="app-header__spacer" />

            <div className="app-header__tools">
                <ApprovalNotification />
                <ActivityNotification />
                <UserNotification />
                <AssistantTrigger />
                <div className="app-header__sep" />
                <UserPreferenceManager />
            </div>
        </header>
    );
}
